import {
    GET_SMB_PAYMENT_METHOD_RESPONSE,
    GET_SMB_CARDS_REQUEST,
    GET_SMB_CARDS_RESPONSE,
    SMB_LOGIN_REQUEST,
    SMB_LOGIN_RESPONSE,
    SET_SMB_DELIVERY_STYLE,
    SET_SMB_DETAILS_ENTRY_TYPE,
    SET_SMB_GRID_DATA,
    SET_SMB_SELECTED_PRODUCT,
    UPDATE_SMB_GRID_DATA_ROW,
    SMB_REGISTRATION_REQUEST,
    SMB_REGISTRATION_RESPONSE,
    RESET_SMB_PAYMENT_METHOD_RESPONSE,
    UPDATE_SMB_PAYMENT_METHOD_RESPONSE,
    SET_SMB_PAYMENT_REQUIRES_ACTION,
    RESET_SMB_PAYMENT_REQUIRES_ACTION,
    SET_SMB_CHECKOUT_PAYMENT_METHOD,
    CREATE_SMB_PAYMENT_INTENT_RESPONSE,
    CREATE_SMB_ORDER_RESPONSE,
    SMB_ORDER_CANCELLED,
    SMB_GET_CART_CONTENTS_RESPONSE,
    SMB_ADD_TO_CART,
    GET_SMB_VIRTUAL_GIFT_TEMPLATES_REQUEST,
    GET_SMB_VIRTUAL_GIFT_TEMPLATES_RESPONSE,
    SET_SMB_SELECTED_GIFT_TEMPLATE,
    SMB_SET_CART_FLYOUT_MODE,
    SMB_MARK_CART_ITEM_FOR_DELETION,
    SMB_ITEMS_SYNCED_TO_BACKEND,
    SMB_CHECK_LOGIN_RESPONSE,
    SMB_RESET_CART,
    SMB_SET_ORDER_STATUS,
    CREATE_SMB_ORDER_REQUEST,
    CREATE_SMB_PAYMENT_INTENT_REQUEST,
    UPDATE_SMB_PAYMENT_METHOD_REQUEST,
    SMB_SET_EDIT_ITEM,
    SMB_EDIT_CART_ITEM_REQUEST,
    SMB_EDIT_CART_ITEM_RESPONSE,
    SMB_CLEAR_EDIT_SUCCESS,
    SMB_CANCEL_EDIT_ITEM,
    SMB_SET_COBRAND_BUILDER_STEP,
    SMB_UPDATE_COBRAND_CARD,
    SMB_UPDATE_COBRAND_CARD_BACKGROUND,
    SMB_SEND_COBRAND_FOR_APPROVAL_RESPONSE,
    SMB_SET_SUBMITTING_COBRAND_FOR_APPROVAL,
    SMB_UPDATE_COBRAND_CARD_CLOUDINARY_ID,
    SMB_COPY_CART_SUCCESS,
    SMB_GET_USER_COBRANDS_REQUEST,
    SMB_GET_USER_COBRANDS_RESPONSE,
    SMB_RESET_COBRAND_BUILDER,
    SMB_UPDATE_COBRAND_CARD_LOGO,
    SMB_UPDATE_COBRAND_CARD_LOGO_ZOOM,
} from '../actions/smbCart'
import {
    CART_SOURCE,
    DELIVERY_STYLE,
    ORDER_STATUS,
} from '../containers/SMBOrderFlow'
import {
    DIGITAL_ATTRIBUTES,
    PHYSICAL_ATTRIBUTES,
} from '../components/SmallBusiness/OrderFlow/CustomizationGridAttributes'
import CobrandCard from '../components/Models/CobrandCard'
import { v4 as uuidv4 } from 'uuid'
import has from 'lodash/has'
import isNil from 'lodash/isNil'

export const initialState = {
    selectedProduct: null,
    productData: [],
    productDataError: null,
    productDataIsLoading: false,
    virtualGiftTemplates: null,
    virtualGiftTemplatesAreLoading: false,
    gridData: [],
    user: null,
    isLoggedIn: false,
    loginIsLoading: false,
    loginError: null,
    registrationIsLoading: false,
    registrationError: null,
    paymentMethods: [],
    paymentMethodError: null,
    paymentMethodSaved: false,
    checkoutPaymentMethod: null,
    isSavingPayment: false,
    stripeClientSecret: null,
    paymentRequiresAction: false,
    orderStatus: ORDER_STATUS.INCOMPLETE,
    cancelReason: null,
    orderResponse: {
        order: null,
        cards: [],
    },
    itemsPayload: {
        source: CART_SOURCE,
        delivery_groups: [],
        cards: [],
    },
    cartContents: null,
    cartFlyoutMode: {
        display: false,
        addingToCart: false,
        addedToCart: false,
    },
    cartItemMarkedForDeletion: {
        openModal: false,
        cartId: null,
        item: null,
    },
    syncError: null,
    editingCartItemDeliveryGroupId: null,
    cartItemsCustomizationData: [],
    editCartItemLoading: false,
    editCartItemError: null,
    editCartItemSuccess: false,
    cobrandBuilderStep: -1,
    cobrandCard: new CobrandCard(),
    submittingCobrandForApproval: false,
    sendCobrandForApprovalError: null,
    userCobrands: [],
}

const resetRequestedFlag = (action) =>
    has(action, 'meta') &&
    !isNil(action.meta) &&
    !isNil(action.meta.resetRequested)
        ? { resetRequested: true }
        : {}

export default function smbCartReducer(state = initialState, action) {
    switch (action.type) {
        case GET_SMB_CARDS_REQUEST:
            return { ...state, productDataIsLoading: true }
        case GET_SMB_CARDS_RESPONSE:
            if (action.error) {
                return {
                    ...state,
                    selectedProduct: null,
                    gridData: [],
                    productData: [],
                    productDataError: action.payload,
                    productDataIsLoading: false,
                }
            }
            return {
                ...state,
                selectedProduct: {
                    ...state.selectedProduct,
                    product: action.payload.data[0],
                    deliveryStyle: null,
                    detailsEntryType: null,
                },
                gridData: [],
                productData: action.payload.data,
                productDataError: null,
                productDataIsLoading: false,
            }
        case GET_SMB_VIRTUAL_GIFT_TEMPLATES_REQUEST:
            return { ...state, virtualGiftTemplatesAreLoading: true }
        case GET_SMB_VIRTUAL_GIFT_TEMPLATES_RESPONSE:
            return {
                ...state,
                virtualGiftTemplates: action.payload.templates,
                virtualGiftTemplatesAreLoading: false,
            }
        case SET_SMB_SELECTED_GIFT_TEMPLATE:
            return {
                ...state,
                selectedProduct: {
                    ...state.selectedProduct,
                    selectedGiftTemplate: action.payload,
                },
            }
        case SMB_LOGIN_REQUEST:
            return { ...state, loginIsLoading: true }
        case SMB_LOGIN_RESPONSE:
            if (action.error) {
                return {
                    ...state,
                    loginError: action.payload,
                    loginIsLoading: false,
                }
            }
            return {
                ...state,
                loginError: null,
                loginIsLoading: false,
            }
        case SMB_REGISTRATION_REQUEST:
            return {
                ...state,
                registrationIsLoading: true,
            }
        case SMB_REGISTRATION_RESPONSE:
            if (action.error) {
                return {
                    ...state,
                    registrationError: action.payload,
                    registrationIsLoading: false,
                }
            }
            return {
                ...state,
                registrationError: null,
                registrationIsLoading: false,
            }
        case SET_SMB_SELECTED_PRODUCT:
            if (action.payload === null) {
                return {
                    ...state,
                    selectedProduct: null,
                }
            }

            return {
                ...state,
                selectedProduct: {
                    ...(state.selectedProduct || {}),
                    product: action.payload.product,
                    deliveryStyle:
                        action.payload.deliveryStyle ||
                        has(state.selectedProduct, 'deliveryStyle')
                            ? state.selectedProduct.deliveryStyle
                            : null,
                    detailsEntryType:
                        action.payload.detailsEntryType ||
                        has(state.selectedProduct, 'detailsEntryType')
                            ? state.selectedProduct.detailsEntryType
                            : null,
                },
            }
        case SET_SMB_DELIVERY_STYLE:
            return {
                ...state,
                selectedProduct: {
                    ...state.selectedProduct,
                    deliveryStyle: action.payload,
                },
            }
        case SET_SMB_DETAILS_ENTRY_TYPE:
            return {
                ...state,
                selectedProduct: {
                    ...state.selectedProduct,
                    detailsEntryType: action.payload,
                },
            }
        case SET_SMB_GRID_DATA:
            return {
                ...state,
                gridData: action.payload,
            }
        case UPDATE_SMB_GRID_DATA_ROW:
            if (action.payload && action.payload.removeAddressFields) {
                return {
                    ...state,
                    gridData: state.gridData.map((row) => {
                        let rowData = row
                        if (row.hasOwnProperty('address')) {
                            const { address, ...restOfRowData } = row
                            rowData = restOfRowData
                        }
                        if (row.hasOwnProperty('emailAddress')) {
                            const { emailAddress, ...restOfRowData } = row
                            rowData = restOfRowData
                        }
                        return rowData
                    }),
                }
            }
            return {
                ...state,
            }
        case GET_SMB_PAYMENT_METHOD_RESPONSE:
            if (action.error) {
                return {
                    ...state,
                    paymentMethodError: action.payload,
                }
            }
            return {
                ...state,
                paymentMethods: Array.isArray(action.payload.data)
                    ? action.payload.data
                    : [],
            }
        case UPDATE_SMB_PAYMENT_METHOD_REQUEST:
            return {
                ...state,
                paymentMethodError: null,
            }
        case UPDATE_SMB_PAYMENT_METHOD_RESPONSE:
            if (action.error) {
                return {
                    ...state,
                    paymentMethods: [],
                    paymentMethodError: action.payload,
                    checkoutPaymentMethod: null,
                }
            }
            return {
                ...state,
                paymentMethodSaved: true,
                paymentMethodError: null,
                checkoutPaymentMethod: action.payload,
            }
        case RESET_SMB_PAYMENT_METHOD_RESPONSE:
            return {
                ...state,
                paymentMethodSaved: false,
            }
        case CREATE_SMB_PAYMENT_INTENT_REQUEST:
            return {
                ...state,
                paymentMethodError: null,
            }
        case CREATE_SMB_PAYMENT_INTENT_RESPONSE:
            if (action.error) {
                return {
                    ...state,
                    paymentMethodError: action.payload,
                }
            }
            return {
                ...state,
            }
        case SET_SMB_PAYMENT_REQUIRES_ACTION:
            return {
                ...state,
                paymentRequiresAction: true,
                stripeClientSecret: action.payload,
            }
        case RESET_SMB_PAYMENT_REQUIRES_ACTION:
            return {
                ...state,
                paymentRequiresAction: false,
            }
        case SET_SMB_CHECKOUT_PAYMENT_METHOD:
            return {
                ...state,
                checkoutPaymentMethod: action.payload,
            }
        case CREATE_SMB_ORDER_REQUEST:
            return {
                ...state,
                orderError: null,
                orderStatus: ORDER_STATUS.INCOMPLETE,
            }
        case CREATE_SMB_ORDER_RESPONSE:
            if (action.error) {
                return {
                    ...state,
                    orderError: action.payload.errors,
                }
            }
            return {
                ...state,
                orderStatus: ORDER_STATUS.COMPLETE,
                orderResponse: {
                    order: action.payload.order,
                    cards: action.payload.cards,
                },
            }
        case SMB_ORDER_CANCELLED:
            return {
                ...state,
                orderStatus: ORDER_STATUS.CANCELLED,
                cancelReason: action.payload.cancelReason,
                orderResponse: {
                    order: action.payload.order,
                    cards: action.payload.cards,
                },
            }
        case SMB_SET_ORDER_STATUS:
            return {
                ...state,
                orderStatus: action.payload,
            }
        case SMB_GET_CART_CONTENTS_RESPONSE:
            if (action.error || !has(action.payload, 'cart')) {
                return {
                    ...state,
                    // set generic error?
                }
            }
            return {
                ...state,
                cartContents: { ...action.payload.cart },
                cartItemsCustomizationData: getCustomizationDataFromCartContents(
                    action.payload.cart
                ),
            }
        case SMB_ADD_TO_CART:
            return {
                ...state,
                itemsPayload: {
                    ...state.itemsPayload,
                    delivery_groups: [
                        ...(state.itemsPayload.delivery_groups || []),
                        action.payload.newDeliveryGroup,
                    ],
                    cards: [
                        ...(state.itemsPayload.cards || []),
                        ...action.payload.newCards,
                    ],
                },
                ...resetRequestedFlag(action),
            }
        case SMB_RESET_CART:
            return {
                ...state,
                cartContents: null,
                cartFlyoutMode: {
                    ...state.cartFlyoutMode,
                    addedToCart: false,
                },
            }
        case SMB_MARK_CART_ITEM_FOR_DELETION:
            return {
                ...state,
                cartItemMarkedForDeletion: {
                    openModal: action.payload.openModal,
                    cartId: action.payload.cartId,
                    item: action.payload.item,
                },
            }
        case SMB_SET_CART_FLYOUT_MODE:
            return {
                ...state,
                cartFlyoutMode: {
                    ...state.cartFlyoutMode,
                    ...action.payload,
                },
            }
        case SMB_ITEMS_SYNCED_TO_BACKEND:
            let removingFromCart = false
            if (has(action.meta, 'removingFromCart')) {
                removingFromCart = action.meta.removingFromCart
            }
            return action.error || !has(action.payload, 'cart')
                ? {
                      ...state,
                      itemsPayload: {
                          source: CART_SOURCE,
                          delivery_groups: [],
                          cards: [],
                      },
                      syncError: {
                          code: action.payload.error_code,
                          message: action.payload.message || '',
                      },
                  }
                : !removingFromCart
                ? {
                      ...state,
                      cartContents: { ...action.payload.cart },
                      itemsPayload: {
                          ...state.itemsPayload,
                          delivery_groups: [],
                          cards: [],
                      },
                      gridData: [], // only reset if add to cart sync was successful
                      syncError: null,
                  }
                : {
                      ...state,
                      cartContents: { ...action.payload.cart },
                      syncError: null,
                  }
        case SMB_CHECK_LOGIN_RESPONSE:
            return {
                ...state,
                isLoggedIn: action.payload.isLoggedIn,
                user: action.payload.user,
            }
        case SMB_SET_EDIT_ITEM:
            return {
                ...state,
                editingCartItemDeliveryGroupId: action.payload,
                selectedProduct: getCustomizationProductData(
                    state.cartItemsCustomizationData,
                    action.payload
                ),
                gridData: getCustomizationGridData(
                    state.cartItemsCustomizationData,
                    action.payload
                ),
            }
        case SMB_CANCEL_EDIT_ITEM:
            return {
                ...state,
                editingCartItemDeliveryGroupId: null,
                selectedProduct: null,
                gridData: [],
                editCartItemError: null,
            }
        case SMB_EDIT_CART_ITEM_REQUEST:
            return {
                ...state,
                itemsPayload: {
                    ...state.itemsPayload,
                    delivery_groups: [
                        ...(state.itemsPayload.delivery_groups || []),
                        action.payload.newDeliveryGroup,
                    ],
                    cards: [
                        ...(state.itemsPayload.cards || []),
                        ...action.payload.newCards,
                    ],
                },
                editCartItemLoading: true,
                editCartItemError: null,
                editCartItemSuccess: false,
            }
        case SMB_EDIT_CART_ITEM_RESPONSE:
            if (action.error) {
                return {
                    ...state,
                    editCartItemError: action.payload,
                    editCartItemLoading: false,
                    editCartItemSuccess: false,
                }
            }
            return {
                ...state,
                editCartItemError: null,
                editCartItemLoading: false,
                editCartItemSuccess: true,
                editingCartItemDeliveryGroupId: null,
            }
        case SMB_CLEAR_EDIT_SUCCESS:
            return { ...state, editCartItemSuccess: false }
        case SMB_COPY_CART_SUCCESS:
            return { ...state, cartContents: { ...action.payload.cart } }
        case SMB_SET_COBRAND_BUILDER_STEP:
            return {
                ...state,
                cobrandBuilderStep: action.payload,
            }
        case SMB_UPDATE_COBRAND_CARD:
            return {
                ...state,
                cobrandCard: action.payload,
            }
        case SMB_UPDATE_COBRAND_CARD_BACKGROUND:
            return {
                ...state,
                cobrandCard: {
                    ...state.cobrandCard,
                    previewImage: action.payload.previewImage,
                    compositeBackgroundAndLogoImage:
                        action.payload.compositeBackgroundAndLogoImage,
                },
            }
        case SMB_UPDATE_COBRAND_CARD_LOGO:
            return {
                ...state,
                cobrandCard: {
                    ...state.cobrandCard,
                    logo: action.payload,
                },
            }
        case SMB_UPDATE_COBRAND_CARD_LOGO_ZOOM:
            return {
                ...state,
                cobrandCard: {
                    ...state.cobrandCard,
                    logoZoom: action.payload,
                },
            }
        case SMB_UPDATE_COBRAND_CARD_CLOUDINARY_ID:
            return {
                ...state,
                cobrandCard: {
                    ...state.cobrandCard,
                    cloudinaryId: action.payload,
                },
            }
        case SMB_SET_SUBMITTING_COBRAND_FOR_APPROVAL:
            return {
                ...state,
                submittingCobrandForApproval: action.payload,
            }
        case SMB_SEND_COBRAND_FOR_APPROVAL_RESPONSE:
            if (action.error) {
                return {
                    ...state,
                    submittingCobrandForApproval: false,
                    sendCobrandForApprovalError: action.payload,
                }
            }
            return {
                ...state,
                submittingCobrandForApproval: false,
                sendCobrandForApprovalError: null,
            }
        case SMB_GET_USER_COBRANDS_REQUEST:
            return { ...state, userCobrandsAreLoading: true }
        case SMB_GET_USER_COBRANDS_RESPONSE:
            if (action.error) {
                return {
                    ...state,
                    userCobrands: [],
                    userCobrandsError: action.payload,
                    userCobrandsAreLoading: false,
                }
            }
            const { data } = action.payload
            return {
                ...state,
                // Assuming we don't want user data (user_id, email, name) stored in Redux
                userCobrands: data.map((userCobrandData) => {
                    const { user, ...restOfUserCobrandData } = userCobrandData
                    return restOfUserCobrandData
                }),
                userCobrandsError: null,
                userCobrandsAreLoading: false,
            }
        case SMB_RESET_COBRAND_BUILDER:
            return {
                ...state,
                cobrandBuilderStep: -1,
                cobrandCard: new CobrandCard(),
                submittingCobrandForApproval: false,
                sendCobrandForApprovalError: null,
            }
        default:
            return state
    }
}

// Gets gridData for for cart items for the given deliveryGroupId
function getCustomizationGridData(dataItems, deliveryGroupId) {
    return (
        dataItems.filter(
            (item) => item.deliveryGroup.uuid === deliveryGroupId
        )[0]?.gridData || []
    )
}

// Gets selectedProduct data for cart items for the given deliveryGroupId
function getCustomizationProductData(dataItems, deliveryGroupId) {
    const dataItem = dataItems.filter(
        (item) => item.deliveryGroup.uuid === deliveryGroupId
    )[0]
    return {
        product: dataItem?.product || null,
        deliveryStyle: dataItem?.deliveryGroup.delivery_style || null,
        detailsEntryType: dataItem?.detailsEntryType || null,
        selectedGiftTemplate: dataItem?.selectedGiftTemplate || null,
    }
}

// Use the cart response object to build a data structure that can be used
// to edit cart items.
function getCustomizationDataFromCartContents(cart) {
    return cart.delivery_groups.map((deliveryGroup) => {
        const deliveryGroupCards = cart.cart_items.filter((item) => {
            return item.delivery_group_uuid === deliveryGroup.uuid
        })
        const individualDeliveryStyle =
            deliveryGroup.delivery_style === DELIVERY_STYLE.INDIVIDUAL ||
            deliveryGroup.delivery_style === DELIVERY_STYLE.INDIVIDUAL_EMAIL
        return {
            deliveryGroup: deliveryGroup,
            detailsEntryType: 'manual',
            product: {
                ...deliveryGroupCards[0].custom_card_details.wcp_product,
                cobrand_uuid: deliveryGroupCards[0].cobrand_uuid ?? undefined,
            },
            selectedGiftTemplate: deliveryGroupCards[0].on_demand_gift_template,
            gridData: deliveryGroupCards.map((card) => {
                if (card.plastic) {
                    const gridRowData = {
                        rowId: uuidv4(),
                        [PHYSICAL_ATTRIBUTES.AMOUNT.name]:
                            card.custom_card_details.load_value,
                        [PHYSICAL_ATTRIBUTES.NAME_ON_CARD.name]:
                            card.custom_card_details.recipient_name,
                        [PHYSICAL_ATTRIBUTES.CARD_MESSAGE.name]:
                            card.custom_card_details.emboss_message,
                        [PHYSICAL_ATTRIBUTES.CARRIER_TO.name]:
                            card.custom_card_details.shipping_name,
                        [PHYSICAL_ATTRIBUTES.CARRIER_FROM.name]:
                            card.custom_card_details.carrier_from,
                        [PHYSICAL_ATTRIBUTES.CARRIER_MESSAGE.name]:
                            card.custom_card_details.carrier_message,
                    }
                    if (individualDeliveryStyle) {
                        gridRowData[PHYSICAL_ATTRIBUTES.SHIP_TO.name] = {
                            name: card.custom_card_details.shipping_name,
                            addressLine1:
                                card.custom_card_details.address_line1,
                            addressLine2:
                                card.custom_card_details.address_line2,
                            city: card.custom_card_details.city,
                            state: card.custom_card_details.state,
                            zip: card.custom_card_details.zip_code,
                        }
                    }
                    return gridRowData
                } else {
                    return {
                        rowId: uuidv4(),
                        [DIGITAL_ATTRIBUTES.AMOUNT.name]:
                            card.custom_card_details.load_value,
                        [DIGITAL_ATTRIBUTES.FIRST_NAME
                            .name]: card.custom_card_details.recipient_name.split(
                            ' '
                        )[0],
                        [DIGITAL_ATTRIBUTES.LAST_NAME
                            .name]: card.custom_card_details.recipient_name.split(
                            ' '
                        )[1],
                        [DIGITAL_ATTRIBUTES.EMAIL_MESSAGE.name]:
                            card.custom_card_details.recipient_message,
                        [DIGITAL_ATTRIBUTES.EMAIL_ADDRESS.name]:
                            card.custom_card_details.recipient_email,
                    }
                }
            }),
        }
    })
}
